<template>
  <v-card>
    <v-card-title>
      {{tv ? 'Edit' : 'Add'}} {{modalType}}
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-text-field
          label="Name"
          v-model="name"
          :rules="nameRules"
          @blur="checkName"
          :counter="35"
          required></v-text-field>
        <v-select
          label="Group"
          v-model="group"
          :items="groupNames"
          :rules="[v => !!v || 'Group is required']"
          required></v-select>
        <v-text-field
          label="IP"
          v-model="IP"
          :rules="IPRules"
          @blur="checkIP"
          :counter="35"
          required></v-text-field>
        <v-text-field
          v-if="modalType !== 'Tablet'"
          label="Description"
          v-model="description"
          :rules="descriptionRules"
          :counter="35"
          required></v-text-field>
      </v-form>
    </v-card-text>
    <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">
      {{err}}
    </v-alert>
    <v-layout column align-end class="px-2">
      <a
        @click.prevent="submit"
        class="modal-button black--text"
        :disabled="!valid">
        <v-btn :disabled="!valid" fab dark small color="primary">
          <v-icon dark>arrow_forward</v-icon>
        </v-btn>
        Submit
      </a>  
      <a
        @click.prevent="$emit('close')"
        class="modal-button black--text">
        <v-btn fab dark small color="accent">
          <v-icon dark>close</v-icon>
        </v-btn>
        Close
      </a>
    </v-layout>
  </v-card>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    props: ['modalType', 'tv'],
    data: () => ({
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 35) || 'Name must be less than 35 characters',
      ],
      description: '',
      descriptionRules: [
        v => !!v || 'Description is required',
      ],
      IP: '',
      IPRules: [
        v => !!v || 'IP is required',
        v => (v &&
          /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v))
          || 'IP is not valid',
      ],
      group: null,
      groups: [],
      groupNames: [],
      err: '',
    }),
    methods: {
      async checkIP() {
        this.err = '';
        const where = {};
        where.ip = this.IP;
        if (this.tv) {
          where.id = this.tv._id;
        }
        const res = await webHelper.post(this, 'tv/ip', where);
        if (res.failed || !res.isIPavailable) {
          this.err = 'IP You chose is already taken.';
        }
      },
      async checkName() {
        this.err = '';
        const where = {};
        where.name = this.name;
        if (this.tv) {
          where.id = this.tv._id;
        }
        const res = await webHelper.post(this, 'tv/name', where);
        if (res.failed || !res.isNameAvailable) {
          this.err = 'Name You chose is already taken.';
        }
      },
      async submit() {
        this.err = '';
        let selectedGroup;
        const type = this.modalType === 'Tablet' ? 1 : 0;
        if (this.$refs.form.validate()) {
          this.groups.forEach((group) => {
            if (this.group === group.name) {
            // eslint-disable-next-line
              selectedGroup = group._id;
              this.group = group;
            }
          });
        }
        const tv = {
          name: this.name,
          type,
          group: selectedGroup,
          IP: this.IP,
        };

        if (this.modalType !== 'Tablet') {
          Object.assign(tv, { description: this.description });
        }
        let res;
        if (this.tv) {
          // eslint-disable-next-line
          Object.assign(tv, { id: this.tv._id });
          res = await webHelper.put(this, 'tv', tv);
          Object.assign(tv, { _id: this.tv._id });
          delete tv.id;
        } else {
          res = await webHelper.post(this, 'tv', tv);
          Object.assign(tv, { _id: res.id });
        }
        tv.group = this.group;
        if (res.failed) {
          this.err = 'Failed to save data.';
          return;
        }
        this.$emit('submit', tv);
      },
    },
    async created() {
      const res = await webHelper.get(this, 'group');
      this.groups = res.groups;
      if (this.groups === null) {
        this.err = 'Error getting groups. Please try again.';
        return;
      }
      this.groupNames = this.groups.map(group => group.name);
      if (this.tv) {
        this.name = this.tv.name;
        this.type = this.tv.type === 0 ? 'TV' : 'Tablet';
        this.group = this.tv.group.name;
        this.IP = this.tv.IP;
        this.description = this.tv.description;
      } else {
        this.types = [this.modalType];
        this.type = this.modalType;
      }
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/Tv.vue